import { render, staticRenderFns } from "./WRecordAudio.vue?vue&type=template&id=5cacf9dc&"
import script from "./WRecordAudio.vue?vue&type=script&lang=js&"
export * from "./WRecordAudio.vue?vue&type=script&lang=js&"
import style0 from "./WRecordAudio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WGrabar from '@/components/WGrabar.vue'
import WLoading from '@/components/WLoading.vue'
autoInstallComponents(component, {WGrabar,WLoading})
